// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapouter {
  position: relative;
  text-align: right;
  height: 500px;
  width: 100%;
}

.gmap_canvas {
  overflow: hidden;
  background: none !important;
  height: 500px;
  width: 100%;
}

  .gmap_canvas iframe {
    width: 100%;
  }
`, "",{"version":3,"sources":["webpack://./src/app/contact/contact.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;;EAEE;IACE,WAAW;EACb","sourcesContent":[".mapouter {\r\n  position: relative;\r\n  text-align: right;\r\n  height: 500px;\r\n  width: 100%;\r\n}\r\n\r\n.gmap_canvas {\r\n  overflow: hidden;\r\n  background: none !important;\r\n  height: 500px;\r\n  width: 100%;\r\n}\r\n\r\n  .gmap_canvas iframe {\r\n    width: 100%;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
